import React from 'react';
import { Link } from 'react-router-dom';

export default function ManagementCard({
  icon,
  title,
  description,
  stats,
  actions,
  badgeCount,
  badgeType = 'new', // 'new', 'update'
  hasUpdates = false,
  to,
  onClick,
  colorScheme = 'default' // 'allowance', 'activities', 'ideas', 'settings'
}) {
  const cardClasses = `management-card ${colorScheme}${hasUpdates ? ' has-updates' : ''}`;
  
  const CardContent = () => (
    <>
      {badgeCount && (
        <div className={`card-badge ${badgeType}`}>
          {badgeCount}
        </div>
      )}
      
      <div className={`card-icon ${colorScheme}`}>
        {icon}
      </div>
      
      <div className="card-title">{title}</div>
      
      <div className="card-description">{description}</div>
      
      {stats && stats.length > 0 && (
        <div className="card-stats">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      )}
      
      {actions && actions.length > 0 && (
        <div className="card-actions">
          {actions.map((action, index) => (
            <button 
              key={index}
              onClick={action.onClick}
              className={`card-btn ${action.primary ? 'primary' : ''}`}
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cardClasses}>
        <CardContent />
      </Link>
    );
  }

  return (
    <div className={cardClasses} onClick={onClick}>
      <CardContent />
    </div>
  );
}